<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('reports.title')"></page-header-title>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex lg3 md6>
          <v-select
            name="report"
            v-model="selectedReport"
            item-text="text"
            item-value="key"
            :items="this.$dd_reports()"
            :label="$t('reports.select_report')"
            clearable
          ></v-select>
        </v-flex>
        <v-flex md12>
          <component :is="selectedReport"></component>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Report",

  components: {
    "course-overview": () => import("../components/reports/CourseOverview"),
    "student-course-overview": () => import("../components/reports/StudentCourseOverview"),
    billing: () => import("../components/reports/Billing"),
    "detailed-enrolment": () => import("../components/reports/DetailedEnrolment")
  },

  data() {
    return {
      reports: [],
      selectedReport: null
    }
  },
  created() {},
  methods: {
    reportChange() {}
  }
}
</script>
